import { spacing } from '../..';
import { Flex } from '../Flex/Flex';
import type { Key } from '../Select/Item';
import { Item } from '../Select/Item';
import { Text } from '../Text/Text';
import * as styles from './Phone.css';
import type { SupportedCountryType } from './utils';

export interface PhoneCountryListItemProps {
  readonly country: SupportedCountryType;
  readonly selected: boolean;
  readonly onSelectCountry: (value: Key) => void;
}

export const PhoneCountryListItem: React.FC<PhoneCountryListItemProps> = ({
  country: { iso, flag, name, countryCallingCode },
  selected,
  onSelectCountry,
}) => {
  return (
    <Item className={styles.phoneListItem({ selected })} onAction={onSelectCountry} value={iso.toUpperCase()}>
      <Flex alignItems="center" width={selected ? `calc(100% - ${spacing.s32})` : '100%'}>
        <Text as="span" type="h4">
          {flag}
        </Text>
        <Text as="span" className={styles.listItemCountryName} ml={spacing.s12} mr={spacing.s04} type="bodyMedium">
          {name}
        </Text>
        {countryCallingCode != null && <span>(+{countryCallingCode})</span>}
      </Flex>
    </Item>
  );
};
